import { Observable, Subscriber } from 'rxjs';
import { Component, OnInit, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormArray, FormBuilder, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { CarIn } from '../mes-vehicules/cars/cars-dialog/car-in';
import { TemplateSearchCar } from 'src/app/app.models';
import { SinistreService } from 'src/app/services/sinistre.service';
import { ToastrService } from "ngx-toastr";
import { FormGroup } from '@angular/forms';
import { CarsService } from 'src/app/services/cars.service';
import { NgxSpinnerService } from 'ngx-spinner';

export interface HoursPut {

  id: number,
  name: string,
  value: string,
}

@Component({
  selector: "app-sinitre-new",
  templateUrl: "./sinitre-new.component.html",
  styleUrls: ["./sinitre-new.component.scss"],
})

export class SinitreNewComponent implements OnInit {
  public Formcar!: UntypedFormGroup;
  images: string[] = [];
  public code: any;
  public item: any;
  public choice: any;
  public itemCarac: any;
  public data: any;
  public userIn: any;
  public selected2: any;
  favorite: string;
  etats: string[] = ['Accident avec un autre véhicule', 'Bris de glace', 'Incendie', 'Vol', 'choc n\'impliquant pas un autre vehicule', 'Autre'];
  public valueDatePickerEnd?: Date;
  public minDateStart: Date;
  public minDate: Date;
  public minDateEnd: Date;
  public maxDate: Date;
  public currentDateStart?: string;
  public currentDateEnd?: string;
  dateStart: any;
  dateEnd: any;
  blesse: any;
  temoins: any;
  todayWithPipe: any;
  periodStart?: string;
  // public BlessForm: any;
  periodEnd?: string;
  currentDateFormat?: string;
  templateSearchCar: TemplateSearchCar;

  public tabimg: Array<any> = [];
  public lessonForm: FormGroup;
  public TemoinsForm: FormGroup
  hoursObj: HoursPut[] = [{ id: 1, name: '1H', value: '1' }, { id: 2, name: '2H', value: '2' }, { id: 3, name: '3H', value: '3' }, { id: 4, name: '4H', value: '4' }, { id: 5, name: '5H', value: '5' }, { id: 6, name: '6H', value: '6' }, { id: 7, name: '7H', value: '7' }, { id: 8, name: '8H', value: '8' }, { id: 9, name: '9H', value: '9' }, { id: 10, name: '10H', value: '10' }, { id: 12, name: '12H', value: '12' }, { id: 13, name: '13H', value: '13' }, { id: 14, name: '14H', value: '14' }, { id: 15, name: '15H', value: '15' }, { id: 16, name: '16H', value: '16' }, { id: 17, name: '17H', value: '17' }, { id: 18, name: '18H', value: '18' }, { id: 19, name: '19H', value: '19' }, { id: 20, name: '20H', value: '20' }, { id: 21, name: '21H', value: '21' }, { id: 22, name: '22H', value: '22' }, { id: 23, name: '23H', value: '23' }, { id: 24, name: '24H', value: '24' },];

  partenNumber='(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})';
  Car: any;
  files: File[] = [];


  public rentings: Array<{ [key: string]: any }> = [];
  public idVehicule: number | null;
  constructor(
    public formBuilder: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    private datePipe: DatePipe,
    public carservice: VehiculeserviceService,
    public router: Router,
    public service: CarsService,
    private fb: FormBuilder,
    public sinistreservice: SinistreService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.minDateStart = new Date();
    this.minDateEnd = new Date();
  }

  ngOnInit(): void {
    this.initForm();
    this.getCar();    
    this.carservice.findCar({ code: this.code}).subscribe((data: any) => {
      this.item = data.val;
      this.Formcar.get("id_prop")?.setValue(this.item.prop_id);
    });
  }

  initForm(){
    this.Formcar = this.formBuilder.group({
      file: "",
      sinister_description: ['', Validators.required],
      NomPorprio: ['', Validators.required],
      AdresseProprio: ['', Validators.required],
      ProfessionProprio: ['', Validators.required],
      NomConducteur: ['', Validators.required],
      date_acc: ['', Validators.required],
      AssureA: ['', Validators.required],
      NumPoliceAssurance: ['', Validators.required],
      NatureDegatSurVehicule: ['', Validators.required],
      degats_description: ['', Validators.required],
      NumRapportPV: ['', Validators.required],
      CirconstanceDetaillees: ['', Validators.required],
      reservation: ['', Validators.required],
      lieu_acc: '',
      lieu_act: '',
      NomPrenomBlesse: ['', Validators.required],
      AdresseBlesse: ['', Validators.required],
      NatureBlessure: ['', Validators.required],
      NomPrenomTemoin: ['', Validators.required],
      AdresseTemoin: ['', Validators.required],
      TelTemoins: ['', [Validators.required,Validators.pattern(this.partenNumber)]],
      heureSinistre: ['', Validators.required],
      vehicule: ['', Validators.required],
      lessons: this.fb.array([]),
      temoin: this.fb.array([]),
    });

    this.lessonForm = this.fb.group({
      NomPrenomBlesse: '',
      AdresseBlesse: '',
      NatureBlessure: '',
    });

    this.TemoinsForm = this.fb.group({
      NomPrenomTemoin: '',
      AdresseTemoin: '',
      TelTemoins: ['', [Validators.required,Validators.pattern(this.partenNumber)]]
    });
  }


  public selected(event: any): void {
    this.choice = event.value
  }


  public getCar() {
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    }

    this.carservice.getvehicleSinisterLitige(this.userIn.id, 'sinistre').subscribe((data: any) => {
      this.Car = data;
    });
  }

  resevationVehicule() {
    this.idVehicule = this.Formcar.get('vehicule')?.value as number;
    let vehicule = this.Car.find((elt:any)=>elt.id==this.idVehicule);
    this.rentings=vehicule.rentings
    /*this.rentingService.rentingLitigeOrSinister(this.idVehicule).subscribe((res: any) => {
      this.rentings = res.rentings;
    })*/
  }

  choiseRenting()
  {
    let idReservation = this.Formcar.get('reservation')?.value as number;
    let reservation = this.rentings.find((elt:any)=>elt.id==idReservation);

    this.minDate= reservation?.renting_date_departure
    this.maxDate= reservation?.renting_date_return

  }

  get f() {
    return this.Formcar.controls;
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.images.push(event.target.result);
        };

        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }



  public onInfoFormCoordonneesSubmit(): void {
  
    const maDate_date_acc = this.datePipe.transform(
      this.Formcar.value.date_acc,
      "YYYY-MM-dd"
    );

    this.data = this.Formcar.value;
    this.blesse = this.lessonForm.value;
    this.temoins = this.TemoinsForm.value;
    this.Formcar.get("date_acc")?.setValue(maDate_date_acc);
    
    let mesdonnees = {
      sinister_description: this.data.sinister_description,
      date_sinistre: this.data.date_acc,
      lieu_sinistre: this.data.lieu_acc,
      heureSinistre: this.data.heureSinistre,
      degats_description: this.data.degats_description,
      NomPorprio: this.data.NomPorprio,
      AdresseProprio: this.data.AdresseProprio,
      ProfessionProprio: this.data.ProfessionProprio,
      NomConducteur: this.data.NomConducteur,
      MarkModel: this.data.MarkModel,
      AssureA: this.data.AssureA,
      NumPoliceAssurance: this.data.NumPoliceAssurance,
      NatureSinistre: this.choice,
      lieu_actuel_vehic: this.data.lieu_act,
      NumRapportPV: this.data.NumRapportPV,
      NatureDegatSurVehicule: this.data.NatureDegatSurVehicule,
      CirconstanceDetaillees: this.data.CirconstanceDetaillees,
      etats: this.data.etats,
      decla_id: this.userIn.id,
      vehicle_id: this.data.vehicule,
      reservation: this.data.reservation,
    };

    let temoins=this.data.temoin;
    let blessees=this.data.lessons;
    temoins.push({
      NomPrenomTemoin: this.data.NomPrenomTemoin,
      AdresseTemoin: this.data.AdresseTemoin,
      TelTemoins: this.data.TelTemoins
    });
    blessees.push({
      NomPrenomBlesse: this.data.NomPrenomBlesse,
      AdresseBlesse: this.data.AdresseBlesse,
      NatureBlessure: this.data.NatureBlessure
    });

    let datas={
      fileSource:this.images,
      temoins:temoins,
      blesse:blessees,
      donneesSinister:mesdonnees
    }

    this.spinner.show();

    this.sinistreservice.addsinistre(datas).subscribe((data: any) => {
     
      this.toastr.success("Sinistre declaré ");

      this.spinner.hide();

      this.router.navigateByUrl(
          "/compte-utilisateur/sinistre"
      );
      }
    );

  }


  addItemAcc(newItem: any) {
    this.Formcar.get("lieu_acc")?.setValue(newItem.adress);
  }
  addItemAct(newItem: any) {
    this.Formcar.get("lieu_act")?.setValue(newItem.adress);
  }
  get lessons() {
    return this.Formcar.controls["lessons"] as FormArray;
  }
  get temoin() {
    return this.Formcar.controls["temoin"] as FormArray;
  }


  addLesson() {

    const lessonForm = this.fb.group({
      NomPrenomBlesse: '',
      AdresseBlesse: '',
      NatureBlessure: '',
    });

    this.lessons.push(lessonForm);

  }



  addTemoin() {
    const TemoinsForm = this.fb.group({
      NomPrenomTemoin: '',
      AdresseTemoin: '',
      TelTemoins: '',
    });

    this.temoin.push(TemoinsForm);

  }


  deleteLesson(lessonIndex: number) {
    this.lessons.removeAt(lessonIndex);
    this.sinistreservice.suprimeBlesser(lessonIndex).subscribe((data: any) => {
    })
  }
  deleteTemoin(lessonIndex: number) {
    this.temoin.removeAt(lessonIndex);
    this.sinistreservice.suprimeTemoin(lessonIndex).subscribe((data: any) => {
    })
  }

  onSelect(event: any) {

    if (event.addedFiles && event.addedFiles.length > 0) {

      event.addedFiles.map((obj: any) => {
        
        if(obj.size > 5000000) {

          this.toastr.error('La taille du fichier '+ obj.name+' est supérieure à 5Mo, veuillez sélectionner une autre image');
  
        } else {
  
          let image = this.files.find(img => img.name == obj.name && img.size == obj.size && img.type == obj.type);
          
          if(image == undefined || image == null) {

            this.convertToBase64(obj).subscribe((d:any) => {
              this.images.push(d);              
            })

            this.files.push(obj);

          } else {

            this.toastr.error('L\'image '+ obj.name+' a déjà été sélectionné');

          }
  
        }

      })
    }
  
  }

  onRemove(event : any) {
    let index = this.files.indexOf(event);
    this.files.splice(index, 1);
    this.images.splice(index, 1);
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    })
    return observable
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    }
    fileReader.onerror = () => {
      subscriber.error();
      subscriber.complete();
    }

  }



}